<template>
    <div class="footer">
        <div class="bottom-info container">
            <div>
                <div class="bottom-tips">DOWNLOAD APP</div>
                <div style="position: relative;">
                    <div id="qrcode" ref="qrcode" class="bottom-erweima"></div>
                    <div :style="`background-image: url(${logoImg});`" class="logo-img"></div>
                </div>
                <div class="bottom-contact flex justify-around">
                    <span v-for="(item, index) in infoList" :key="index">
                        <i :class="`iconfont bottom-icon ${item.icon}`"></i>
                        {{item.title}}
                    </span>
                </div>
                <div class="bottom-address flex justify-center">
                    <span class="iconfont icondingwei"></span>
                    <div>
                        <p>
                            Office add : 1389 Yisen Leather Building 5F Shop 5018,
                            Jiefang North Road, Baiyun District, Guangzhou City.
                        </p>
                        <p>
                            Factory add : 10 Bangsheng Third Road, Jinghu Ave,
                            Xinhua Town, Huadu District, Guangzhou City.
                        </p>
                    </div>
                </div>
                <div class="bottom-banquan">
                    <p>WWW.CHRISBELLA.NET</p>
                    <!-- <p>©️2019 粤ICP备12345678号-1</p> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import QRCode from 'qrcodejs2';

export default {
    name: 'BottomInfo',
    data() {
        return {
            infoList: [
                {
                    title: '+86 20 36298252',
                    icon: 'iconweibiaoti-',
                },
                {
                    title: 'CHRISBELLA@AOPIYA.COM',
                    icon: 'iconyouxiang',
                },
                {
                    title: 'facebook: Chrisbella.official',
                    icon: 'iconfacebook',
                },
            ],
            sHeight: '',
            cHeight: '',
            footerHeight: '',
            logoImg: require('@/assets/images/logo.png'),
        };
    },
    watch: {

    },
    methods: {
        qrcode() {
            document.getElementById('qrcode').innerHTML = '';
            const myCode = 'https://aobiya.dev.ganguomob.com/download/';
            const qrcode = new QRCode('qrcode', {
                width: 120, // 设置宽度
                height: 120, // 设置高度
                text: myCode,
            });
        },
    },
    mounted() {
        this.qrcode();
    },
};
</script>

<style lang="scss" scoped>
    .footer {
        background-image: linear-gradient(-180deg, #44A088 0%, #4B9280 100%);
        min-width: 1200px;
    }
    .footer-absolute {
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
    }
    .bottom-info {
        padding-top: 19px;
        > div {
            width: 750px;
            margin: 0 auto;
            color: #FFFFFF;
            text-align: center;
            .bottom-tips {
                padding-top: 26px;
                font-size: 30px;
                letter-spacing: 0.58px;
                line-height: 42px;
            }
            .bottom-erweima {
                width: 120px;
                height: 120px;
                background-position:center;
                background-size: contain;
                background-repeat: no-repeat;
                margin:27px auto;
                padding: 6px;
                background-color: #fff;
            }
            .bottom-contact {
                font-size: 14px;
                line-height: 48px;
            }
            .bottom-banquan {
                padding:42px 0 17px;
                font-size: 12px;
                color: #DDDDDD;
                p:first-child {
                    margin-bottom: 5px;
                }
            }
        }
        .bottom-icon {
            margin-right: 20px;

        }
        .bottom-address {
            span {
                font-size: 18px;
                padding-right: 20px;
                padding-left:22px;
            }
            p {
                text-align: left;
                line-height: 22px;
                font-size: 14px;
            }
        }
    }
    .logo-img {
        width: 50px;
        height: 50px;
        background-color: #fff;
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
        position: absolute;
        border-radius: 50%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
</style>
